import Quill from "quill";
import type { EmbedBlot } from "parchment";
import { Emoji } from "../emojipicker/emoji.types";

const Embed = Quill.import("blots/embed") as typeof EmbedBlot;

class EmojiBlot extends Embed {

    static override blotName = 'tm-emoji';
    static override tagName = 'span';

    static override create(value?: Emoji) {
        let node = super.create();

        if (value && value.unicode) {
            node.textContent = value.unicode;
        } else if (value && typeof value === "string") {
            node.textContent = value;
        }
        return node;
    }

    static override value(node: HTMLElement) {
        return node.innerText;
    }
}

export default EmojiBlot;